import { TextField } from '@mui/material'
import React, { useEffect } from 'react'
import { resetIncentiveValue, updateIncentiveValue, updateIsValid } from '../../../stateManagement/actions/incentiveActions';
import { useSelector } from 'react-redux';
import { IncentiveHeader } from './incentiveHeader/IncentiveHeader';

export const IncentiveTextBox = (props: {stateName:string}) => {
    const componentState = useSelector((state: any) => state?.manageIncentive?.data[props.stateName]);

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.value.length > 250){
            return;
        }
        const trimmedValue = event.target.value.trim();
        updateIncentiveValue(event.target.value, props.stateName);
        updateIsValid(trimmedValue ? true : false,props.stateName);
    };
    return (
        <IncentiveHeader heading={componentState?.label} open={componentState?.isOpen} >
            <TextField
                inputProps={{ maxLength: 60 }}
                size="small"
                variant="outlined"
                placeholder={"Write here"}
                fullWidth
                value={componentState?.value ?? ""}
                onChange={handleOnChange}

            />
        </IncentiveHeader>
    )
}
